import { create } from "zustand";

export const useFootnoteDisplayStore = create((set, get) => ({
  data: {
    title: "",
    titleStyle: "1",
  },
  setData: (value) => set({ data: { ...get().data, ...value } }),
  getData: () => get().data,

  resetStore: () => {
    set({
      data: {
        title: "",
        titleStyle: "1",
      },
    });
  },
}));
